<template>
  <div>
    <LoadingContainer
      :is-loaded="isLoaded"
      :total="subjectsLength"
      kind="Subjects"
    >
      <TransitionList class="subjects-list">
        <li v-for="s in subjects" :key="s.id" class="subject-card">
          <span class="subject-card__color" :aria-label="`Color: ${colorName(s.color)}`" :style="`--color:${s.color}`"></span>

          <span class="subject-card__name">{{ s.name }}</span>

          <button class="subject-card__delete button" @click="deleteSubject(s.id)">
            <span class="u-screen-reader-only">Delete Subject</span>
            <DeleteIcon />
          </button>

          <button class="subject-card__edit button" @click="editSubject(s.id)">
            <span class="u-screen-reader-only">Edit Subject</span>
            <EditIcon />
          </button>

          <ConfirmDelete
            :is-visible="isDeleting(s.id)"
            class="subject-card__confirm"
            :title="s.name"
            @cancel="cancelDelete"
            @confirm="confirmDeleteSubject(s.id)"
          />

          <SubjectForm
            class="subject-card__form"
            v-if="isEditing(s.id)"
            @submit="saveEditedSubject"
            :subject="{...s}"
            :title="`Edit Subject: ${s.name}`"
            @cancel="cancelEditSubject"
          ></SubjectForm>
        </li>
      </TransitionList>
    </LoadingContainer>

    <SubjectForm
      v-if="showAdd"
      @submit="saveNewSubject"
      :subject="newSubject"
      @cancel="clearSubject"
    ></SubjectForm>

    <SettingsAdd v-else @add="addSubject">
      Add Subject
    </SettingsAdd>
  </div>
</template>

<script>
import store from '@/store'
import { mapActions, mapGetters } from 'vuex'

import subjectColors from '@/utils/subject-colors'

import DeleteIcon from 'bootstrap-icons/icons/trash.svg'
import EditIcon from 'bootstrap-icons/icons/pencil-square.svg'
import ConfirmDelete from '@/components/ConfirmDelete'
import SubjectForm from '@/views/Settings/Forms/SubjectForm'

export default {
  name: 'SettingsSubjects',

  components: {
    DeleteIcon,
    EditIcon,
    ConfirmDelete,
    SubjectForm
  },

  data () {
    return {
      subjectColors,
      editingSubject: undefined,
      deletingSubject: undefined,
      newSubject: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoaded: 'subjects/isLoaded',
      subjectsLength: 'subjects/subjectsLength',
      subjects: 'subjects/sortedSubjects'
    }),

    showAdd () {
      return this.$route.query.add
    }
  },

  methods: {
    ...mapActions([
      'subjects/addSubject',
      'subjects/deleteSubject',
      'subjects/editSubject'
    ]),

    colorName (color) {
      const thisColor = this.subjectColors.find(c => c.value === color)

      return thisColor ? thisColor.name : undefined
    },

    editSubject (id) {
      this.editingSubject = id
    },

    isEditing (id) {
      return id === this.editingSubject
    },

    saveEditedSubject (s) {
      this['subjects/editSubject'](s)
      this.editingSubject = undefined
    },

    cancelEditSubject () {
      this.editingSubject = undefined
    },

    deleteSubject (id) {
      this.deletingSubject = id
    },

    isDeleting (id) {
      return id === this.deletingSubject
    },

    cancelDelete () {
      this.deletingSubject = undefined
    },

    confirmDeleteSubject (id) {
      this['subjects/deleteSubject'](id)
      this.deletingSubject = undefined
    },

    addSubject () {
      this.$router.replace({
        name: 'settings-subjects',
        query: {
          add: true
        }
      })
    },

    clearSubject () {
      this.newSubject = {}
      this.$router.replace({
        name: 'settings-subjects'
      })
    },

    saveNewSubject () {
      this['subjects/addSubject'](this.newSubject)

      this.clearSubject()
    }
  },

  mounted () {
    store.dispatch('subjects/getSubjects')
  }
}
</script>

<style lang="scss">
.subject-card {
  margin-bottom: 2rem;
  display: grid;
  grid-template:
    "color .    name delete edit" auto
    "form  form form form   form" auto /
     auto  1rem 1fr  auto   auto;
  align-items: center;
}

.subject-card__color {
  width: 2rem;
  height: 2rem;
  display: inline-block;
  grid-area: color;
  border: .125rem solid #fff;
  border-radius: 1rem;
  background-color: var(--color, var(--color-page-bg));
}

.subject-card__name {
  grid-area: name;
  font-size: 1.4em;
  font-weight: 700;
}

.subject-card__delete {
  --button-fg: #B71C1C;
  --button-fg-active: #D32F2F;
  --button-width: 3rem;

  grid-area: delete;
}

.subject-card__edit {
  --button-fg: #006064;
  --button-fg-active: #0097A7;
  --button-width: 3rem;

  grid-area: edit;
}

.subject-card__form {
  margin-top: 1rem;
  padding: 1rem;
  grid-area: form;
  border-radius: 2.25rem;
  background-color: #fff;
}

.subject-card__confirm {
  grid-area: form;
}
</style>
